<template>
  <button
    :class="[
      'scroll-button',
      variant === 'secondary' ? 'scroll-button--secondary' : 'scroll-button--primary',
      position === 'left' ? 'scroll-button--left' : 'scroll-button--right',
      canScroll ? 'scroll-button--visible' : 'scroll-button--hidden',
    ]"
    @click="$emit('scroll')"
  >
    <img
      :src="Icons.ArrowDown.src"
      :class="[
        'scroll-button__arrow',
        position === 'left' ? 'rotate-90' : '-rotate-90',
        variant === 'secondary' ? 'opacity-50' : '',
      ]"
      :alt="`arrow ${position}`"
    />
  </button>
</template>

<script setup lang="ts">
import { Icons } from "@/core-ui-vue";
import { computed } from "vue";

interface Props {
  position: "left" | "right";
  canScroll: boolean;
  variant?: "primary" | "secondary";
  transformX?: number;
  transformY?: number;
}

const props = withDefaults(defineProps<Props>(), {
  variant: "primary",
  transformX: 0,
  transformY: 0,
});

const computedTransformX = computed(() => (props.position === "left" ? -props.transformX : props.transformX));

defineEmits<{
  (e: "scroll"): void;
}>();
</script>

<style scoped lang="scss">
.scroll-button {
  @apply pointer-events-auto z-10 flex flex-shrink-0 items-center justify-center transition-all duration-500;
  transform: translate(v-bind('computedTransformX + "px"'), v-bind('transformY + "px"'));

  &__arrow {
    @apply h-3 w-3;
  }

  &--primary {
    @apply h-full bg-gradient-to-r;

    &.scroll-button--left {
      @apply from-white to-transparent;
    }

    &.scroll-button--right {
      @apply justify-end from-transparent to-white;
    }

    &.scroll-button--visible {
      @apply w-10 opacity-100 md:w-20;
    }
  }

  &--secondary {
    @apply relative h-12 rounded-full bg-gray-100;

    &.scroll-button--visible {
      @apply w-10 opacity-100 md:w-12;
    }
  }

  &--hidden {
    @apply pointer-events-none w-0 opacity-0;
  }
}
</style>
